import type { SVGProps } from 'react';

export default function EUIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47716 17.5228 2.00002 12 2.00002C6.47714 2.00002 2 6.47716 2 12C2 17.5228 6.47714 22 12 22Z"
        fill="#0052B4"
      />
      <path
        d="M11.9999 5.91311L12.3237 6.90955H13.3713L12.5237 7.52537L12.8475 8.52181L11.9999 7.90596L11.1522 8.52181L11.476 7.52537L10.6284 6.90955H11.6761L11.9999 5.91311Z"
        fill="#FFDA44"
      />
      <path
        d="M7.69578 7.69592L8.62937 8.17154L9.37019 7.43076L9.20625 8.46553L10.1398 8.94119L9.105 9.1051L8.94109 10.1399L8.46543 9.20638L7.43066 9.37033L8.17148 8.62951L7.69578 7.69592Z"
        fill="#FFDA44"
      />
      <path
        d="M5.91309 12L6.90953 11.6763V10.6286L7.52531 11.4762L8.52179 11.1524L7.90589 12L8.52179 12.8477L7.52531 12.5239L6.90953 13.3715V12.3238L5.91309 12Z"
        fill="#FFDA44"
      />
      <path
        d="M7.69578 16.3042L8.17144 15.3706L7.43066 14.6298L8.46547 14.7938L8.94105 13.8602L9.105 14.895L10.1398 15.0589L9.20632 15.5346L9.37019 16.5693L8.62937 15.8285L7.69578 16.3042Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 18.087L11.6761 17.0905H10.6284L11.4761 16.4747L11.1522 15.4784L11.9999 16.0941L12.8475 15.4784L12.5237 16.4747L13.3713 17.0905H12.3236L11.9999 18.087Z"
        fill="#FFDA44"
      />
      <path
        d="M16.3043 16.3042L15.3707 15.8286L14.6299 16.5694L14.7938 15.5345L13.8604 15.0589L14.8951 14.895L15.059 13.8602L15.5346 14.7938L16.5694 14.6298L15.8286 15.3707L16.3043 16.3042Z"
        fill="#FFDA44"
      />
      <path
        d="M18.0871 12L17.0907 12.3238V13.3715L16.4749 12.5239L15.4785 12.8477L16.0943 12L15.4785 11.1524L16.4749 11.4762L17.0907 10.6286V11.6763L18.0871 12Z"
        fill="#FFDA44"
      />
      <path
        d="M16.3043 7.69592L15.8286 8.62951L16.5694 9.37033L15.5346 9.20634L15.059 10.1399L14.8951 9.10509L13.8604 8.94115L14.7938 8.46553L14.6299 7.4308L15.3708 8.17158L16.3043 7.69592Z"
        fill="#FFDA44"
      />
    </svg>
  );
}
